<template>
  <el-card class="userLineChart-container" :body-style="{ padding: '0px' }">
    <div class="userLineChart-main">
      <div class="userLineChart-main-header">
        <p>{{ chartData.title }}</p>
        <!-- <p>书城模块</p>
        <p>点击量</p> -->
      </div>
      <div ref="userLineChart" style="width: 100%;height:300px;"></div>
      <slot></slot>
    </div>
    <!-- card body -->
  </el-card>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    chartData: {
      type: Object
    },
    lineColor: {
      type: String,
      default: "#5493fa"
    }
  },
  data() {
    return {
      myChart: null,
      options: {
        tooltip: {
          trigger: "axis", // 提示类型 'item'
          backgroundColor: "#fff",
          textStyle: {
            color: "#a1a2af",
            fontWeight: "bold"
          },
          borderColor: "#DCDFE6",
          borderWidth: 1
          // axisPointer: {
          //   type: "cross"
          // }
        },
        grid: {
          show: false,
          left: "3%",
          right: "3%",
          top: "10%",
          containLabel: true
        },
        // toolbox: {
        //     show:true,
        //     feature: {
        //         dataView: {readOnly: false},
        //     }
        // },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [],
            axisLine: {
              show: true
            },
            axisTick: {
              show: true
            },
            axisLabel: {
              color: "#a1a2af",
              interval: 0, // 全部显示
              rotate: 65
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            scale: true,
            name: "单位：GB",
            // min: 0,
            // max: 200,
            // interval: 20,
            axisLabel: {
              // formatter: "{value} GB"
            },
            // max: 100,
            min: 0,
            boundaryGap: [0.2, 0.2],
            // interval: 15,
            minInterval: 1,

            axisLine: {
              show: true
            },
            axisTick: {
              show: true
            },
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            name: "",
            type: "line",
            smooth: false,
            data: []
          }
        ]
      }
    };
  },
  methods: {
    tooltip(params) {
      let children = "";
      for (let item of params) {
        children += `<p>diskUsed：${item.data}GB</p>`;
      }
      let document = `
        <div>
          <p>${params[0].name}</p>
          ${children}
        </div>
      `;
      return document;
    },

    chartResize() {
      this.myChart.resize({ width: "auto" });
    },
    initChart() {
      this.myChart ? this.myChart.clear() : "";
      this.myChart = echarts.init(this.$refs.userLineChart);
      this.options.xAxis[0].data = this.chartData.date;
      this.options.series[0].data = this.chartData.count.map(i =>
        (i / Math.pow(1024, 3)).toFixed(2)
      );
      this.options.series[0].name = this.chartData.title;
      this.options.tooltip.formatter = this.tooltip;

      this.myChart.setOption(this.options);
    }
  },

  watch: {
    chartData() {
      this.initChart();
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.chartResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.chartResize);
  }
};
</script>

<style lang="scss" scoped>
.userLineChart-container {
  margin-bottom: 20px;
  &:last-child() {
    margin-bottom: 0;
  }
  .userLineChart-main-header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }
}
</style>
